/** Stay booking is paid (Cashfree succeeded). */
export function isStayBookingPaid(booking) {
  const paymentStatus = String(booking?.paymentStatus || '').toUpperCase();
  return paymentStatus === 'SUCCEEDED' || paymentStatus === 'SUCCESS';
}

/** Paid and waiting for vendor/admin approval. */
export function isStayApprovalPending(booking) {
  const status = String(booking?.status || '').toUpperCase();
  return status === 'APPROVAL_PENDING' && isStayBookingPaid(booking);
}

/** Declined by property owner after payment. */
export function isStayBookingDeclined(booking) {
  const status = String(booking?.status || '').toUpperCase();
  return status === 'DECLINED';
}

/** Approved by vendor/admin (or legacy auto-confirmed). */
export function isStayBookingComplete(booking) {
  const status = String(booking?.status || '').toUpperCase();
  return (status === 'COMPLETED' || status === 'CONFIRMED') && isStayBookingPaid(booking);
}

/** Cancelled by vendor/admin after approval (paid). */
export function isStayBookingCancelled(booking) {
  const status = String(booking?.status || '').toUpperCase();
  return status === 'CANCELLED' && isStayBookingPaid(booking);
}

/** Shown on account / all bookings (excludes unpaid checkout). */
export function isStayBookingVisibleToUser(booking) {
  return (
    isStayApprovalPending(booking) ||
    isStayBookingComplete(booking) ||
    isStayBookingDeclined(booking) ||
    isStayBookingCancelled(booking)
  );
}

/** Vendor/admin may cancel approved stays before check-out date. */
export function canCancelApprovedStayBooking(booking) {
  const status = String(booking?.status || '').toUpperCase();
  if (status !== 'COMPLETED' && status !== 'CONFIRMED') return false;
  const raw = booking?.checkOut;
  if (!raw) return false;
  const checkOut = raw instanceof Date ? raw : new Date(raw);
  if (Number.isNaN(checkOut.getTime())) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  checkOut.setHours(0, 0, 0, 0);
  return checkOut >= today;
}

export function getStayBookingBadge(booking) {
  if (isStayApprovalPending(booking)) {
    return { text: 'Approval Pending', bgColor: 'bg-[#F59E0B]', textColor: 'text-white' };
  }
  if (isStayBookingDeclined(booking)) {
    return { text: 'Declined', bgColor: 'bg-[#EF4444]', textColor: 'text-white' };
  }
  if (isStayBookingComplete(booking)) {
    return { text: 'Completed', bgColor: 'bg-[#10B981]', textColor: 'text-white' };
  }
  if (isStayBookingCancelled(booking)) {
    return { text: 'Cancelled', bgColor: 'bg-gray-500', textColor: 'text-white' };
  }
  const status = String(booking?.status || '').toUpperCase();
  if (status === 'CANCELLED') {
    return { text: 'Cancelled', bgColor: 'bg-gray-400', textColor: 'text-white' };
  }
  return { text: 'In Progress', bgColor: 'bg-[#8B5CF6]', textColor: 'text-white' };
}

export function canOpenStayTicket(booking) {
  return isStayBookingComplete(booking);
}
